import ownerWindow from '@mui/utils/ownerWindow';

export default ownerWindow;
